import { Nav } from 'react-bootstrap';
import './TabsComponent.css';

export interface TabItem {
  key: string;
  title: string;
}

interface TabsComponentProps {
  tabs: TabItem[];
  activeTab: string;
  onTabSelect: (selectedKey: string) => void;
  className?: string;
}

export const TabsComponent = ({
  tabs,
  activeTab,
  onTabSelect,
  className = ''
}: TabsComponentProps) => {
  return (
    <Nav
      variant="tabs"
      activeKey={activeTab}
      onSelect={(selectedKey) => onTabSelect(selectedKey || tabs[0].key)}
      className={`tabs-component ${className}`}
    >
      {tabs.map((tab) => (
        <Nav.Item key={tab.key}>
          <Nav.Link
            eventKey={tab.key}
            className="tab-link"
          >
            {tab.title}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
